module.exports = __webpack_public_path__ + "img/member02.73fd7375.png";